export const RESET_CHANGE_DISPLAY_NAME_OBJ = "RESET_CHANGE_DISPLAY_NAME_OBJ";
export const RESET_CHANGE_DISPLAY_NAME_STATUS = "RESET_CHANGE_DISPLAY_NAME_STATUS";

export const CHANGE_DISPLAY_NAME_ERROR = "CHANGE_DISPLAY_NAME_ERROR";

export const CHANGE_DISPLAY_NAME = "CHANGE_DISPLAY_NAME";
export const CHANGED_DISPLAY_NAME = "CHANGED_DISPLAY_NAME";
